import { ApiUrl, ApiUrlAdmin,ApiUrlDevelop } from "../common/Config";
import { postAdmin,post,get,getAdmin,postFormData } from "../common/Helper";

// Without userId: all active coaches. With userId: only coaches in that
// user's ExamCategory (used by the manual coach assignment).
export const GetAllCoaches = async (token,isAdmin,userId) =>{
    let url = ApiUrlAdmin + `coaching/getbyadminpanel` + (userId ? `?userId=${userId}` : "")
    return await get(url,token,isAdmin)
}
export const GetCoachDetail = async (token,data,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/getbyid?coachId=${data}`
    return await get(url,token,isAdmin)
}
export const AddCoach = async (token,data,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/addCoach`
    return await post(url, data, token);
}
export const UpdateCoach = async (token,data,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/updateCoach`
    return await post(url, data, token);
}
export const GetBadges = async (token,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/getBadges`
    return await get(url,token,isAdmin)
}
export const AddBadge = async (token,data,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/addBadge`
    return await post(url, data, token);
}

export const GetCoachStudents = async (token,data,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/getcoachstudents?coachUserId=${data}`
    return await get(url,token,isAdmin)
}
export const GetCoachMeetings = async (token,data,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/coachmeetings?coachUserId=${data.UserId}&examCategoryId=${data.ExamCategoryId}`
    return await get(url,token,isAdmin)
}

// All coaches' meetings (for the "Tüm Toplantı Kayıtları" page).
//
// The dataset is large (1000+, growing daily), so this is SERVER-SIDE paginated
// and filtered: the client POSTs the page + active filters and gets back one
// page plus totals. It never fetches the whole list.
//
// POST coaching/allcoachmeetings
// body: { pageNumber, pageSize, coachUserId, studentUserId, minDate, maxDate }
// resp: { pageNumber, pageSize, pageCount, totalItemCount, items: [ { meetingId,
//         coachUserId, coachName, coachSurname, studentUserId, studentName,
//         studentSurname, title, date, recordings: [{ id, recordUrl, status }] } ] }
export const GetAllCoachMeetings = async (token, params, isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/allcoachmeeting`
    return await post(url, params, token);
}

// ---- User coaching management ("Kullanıcı Koçluk Yönetimi") ----------------

// Full coaching history of a user (open + closed), newest EndDate first.
// resp: [{ Id, CoachId, CoachName, CoachEmail, StartDate, EndDate, RowStatus }]
export const GetUserCoachings = async (token, userId) =>{
    let url = ApiUrlAdmin + `coaching/getusercoachings?userId=${userId}`
    return await get(url, token)
}

// body: { Id } — closes the assignment (no-op error if already closed).
export const CloseUserCoaching = async (token, data) =>{
    let url = ApiUrlAdmin + `coaching/closeusercoaching`
    return await post(url, data, token);
}

// body: { Id, UserId, StartDate, WeekCount } — backend closes the record and
// inserts a new one with the same coach/credit; FinishDate = StartDate + weeks.
export const UpdateUserCoaching = async (token, data) =>{
    let url = ApiUrlAdmin + `coaching/updateusercoaching`
    return await post(url, data, token);
}

// body: { UserId, CoachId (coach profile Id), StartDate, WeekCount } — fails if
// the user already has an open coaching.
export const AddManualUserCoaching = async (token, data) =>{
    let url = ApiUrlAdmin + `coaching/addmanualusercoaching`
    return await post(url, data, token);
}
